import type { PropsWithChildren } from 'react';

import { CenteredSquaredContainer, FullscreenImageLayout } from '@drycut/ui-components';

type Props = PropsWithChildren<{
  src: string;
}>;

export function ReferralLayout({ src, children }: Props): React.ReactElement {
  return (
    <FullscreenImageLayout src={src}>
      <CenteredSquaredContainer>{children}</CenteredSquaredContainer>
    </FullscreenImageLayout>
  );
}
